import gql from "graphql-tag";

export const TEAMS_QUERY = gql`
  query teams {
    teams {
      id
      name
      lead {
        id
        username
        firstName
        lastName
      }
    }
  }
`;

export const CAPACITY_PLANNING_QUERY = gql`
  query capacityPlanning($anchorDate: Date!) {
    capacityPlanning(anchorDate: $anchorDate) {
      coach
      notStarted
      new
      recurring
      ending
      balance
      forecastChange
      forecastBalance
      dropoffPercent
    }
  }
`;

export const SECONDARY_COACHING_SUBSCRIPTION_QUERY = gql`
  query secondaryUserSubscriptions($secondaryCoachId: ID, $selectedDate: Date) {
    secondaryCoachingSubscriptions(secondaryCoachId: $secondaryCoachId, selectedDate: $selectedDate) {
      subscription {
        id
        startDate
        endDate
        weeksOnProgram
        stage
        active
        onboardingCompleted
        submittedMedicalForm
        programStartDate
        lastMessageSent
        hasCheckinGoal
        hasBhag
        coachChat {
          id
          title
          resolved
          lastMessage {
            id
            text
            sentDate
            messageattachmentSet {
              id
              type
            }
            user {
              id
              isStaff
              firstName
              lastName
            }
            chat {
              id
            }
          }
        }
        upcomingPayment {
          type
          date
        }
        billingOrder {
          id
          nextBillingDate
        }
        metric {
          id
          numberNutritionPics
          exerciseLogged
          numberMessages
        }
        coachactivitySet(forSelectedDate: $selectedDate) {
          edges {
            node {
              id
              dayHalf
              completedAt
            }
          }
        }
        product {
          id
          name
          programType
        }
        coachingAssessments {
          id
          requiredDate
          assessmentDate
        }
        secondaryCoachSubscriptions(period_StartDate_Lte: $selectedDate, periodGraceEndDate: $selectedDate) {
          edges {
            node {
              id
              addedToWhatsapp
              period {
                id
                startDate
                endDate
                coach {
                  id
                  firstName
                  lastName
                }
              }
            }
          }
        }
        user {
          id
          firstName
          lastName
          lastLogin
          email
          username
          subscriptionblockSet {
            id
            currentDay
            startDate
            endDate
            isSelfPaced
            block {
              id
              title
              duration
            }
          }
          subscriptionnutritionblockSet(startDate_Lte: $selectedDate) {
            edges {
              node {
                id
                startDate
                endDate
                nutritionBlock {
                  id
                  title
                }
                subscriptionnutritionblockrecipeSet(date: $selectedDate) {
                  edges {
                    node {
                      id
                      meal
                      recipe {
                        id
                        title
                        meal
                        description
                      }
                    }
                  }
                }
                nutritionBlock {
                  id
                  title
                }
              }
            }
          }
          userProfile {
            id
            phone
            dateOfBirth
            profilePicture
            lastActive
            lastCoachingAssessmentDate
            lastUserAssessmentDate
            engagementScore
            supportChat {
              id
            }
            coachingChat {
              id
              resolved
              lastMessage {
                id
                text
                sentDate
                user {
                  id
                  firstName
                  lastName
                  isStaff
                }
              }
              userchatSet {
                id
                user {
                  id
                }
                lastViewedTimestamp
              }
            }
            nutritionPlan {
              id
              name
              pdf
            }
            coachingNutritionPlan {
              id
              servingSize
              dietaryRestriction
              pdf
            }
          }
        }
      }
    }
  }
`;

export const COACHING_DASHBOARD_LISTING_QUERY = gql`
  query coachDashboardListing(
    $coachId: ID!
    $productType: String
    $stages: [String]
    $productProgramType: String
    $packageCoachId: String
  ) {
    coachDashboardListing(
      coachId: $coachId
      productType: $productType
      stages: $stages
      productProgramType: $productProgramType
      packageCoachId: $packageCoachId
    ) {
      stickyNote
      weeksOnProgram
      lastSubscriptionSurveyId
      coachActivity {
        id
        completedAt
      }
      completedAm
      completedPm
      hasBhag
      hasCheckinGoal
      upcomingPayment {
        type
        date
      }
      nutritionBlock {
        id
        title
      }
      activeWorkoutBlocks {
        id
        currentDay
        startDate
        endDate
        isSelfPaced
        block {
          id
          title
          duration
        }
      }
      nextWorkoutBlocks {
        id
        currentDay
        startDate
        endDate
        block {
          id
          title
          duration
        }
      }
      subscription {
        id
        startDate
        endDate
        transitionProductVariant {
          id
          billingPeriod
          product {
            id
            title
          }
        }
      }
      nutritionPlan {
        name
        pdf
      }
      user {
        id
        email
        firstName
        lastName
        userProfile {
          id
          profilePicture
          dateOfBirth
          lastCoachingAssessmentDate
          lastUserAssessmentDate
          engagementScore
          supportChat {
            id
          }
          coachingChat {
            id
            resolved
            lastMessageTimestamp
            lastMessage {
              id
              text
              sentDate
              messageattachmentSet {
                id
                type
              }
              user {
                id
                isStaff
                firstName
                lastName
              }
              chat {
                id
              }
            }
            userchatSet {
              id
              lastViewedTimestamp
              user {
                id
              }
            }
          }
          coachingNutritionPlan {
            id
            servingSize
            dietaryRestriction
            pdf
          }
        }
      }
    }
  }
`;

export const DAILY_WORKOUT_ACTIVITIES_QUERY = gql`
  query dailyWorkoutActivities($anchorDate: Date!, $subscriptionBlockId: ID!, $activityCount: Int) {
    dailyWorkoutActivities(
      anchorDate: $anchorDate
      subscriptionBlockId: $subscriptionBlockId
      activityCount: $activityCount
    ) {
      activities {
        id
        currentDay
      }
    }
  }
`;
